import React from 'react';
import classNames from 'classnames';
import { SectionSplitProps } from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import Image from '../elements/Image';

const propTypes = {
  ...SectionSplitProps.types,
};

const defaultProps = {
  ...SectionSplitProps.defaults,
};

const FeaturesSplit = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  invertMobile,
  invertDesktop,
  alignTop,
  imageFill,
  ...props
}) => {
  const outerClasses = classNames(
    'features-split section',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'features-split-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  const splitClasses = classNames(
    'split-wrap',
    invertMobile && 'invert-mobile',
    invertDesktop && 'invert-desktop',
    alignTop && 'align-top'
  );

  const sectionHeader = {
    title: 'Gaminio užsakymas',
    paragraph: ' info@inmetal.eu ',
  };

  return (
    <section {...props} className={outerClasses}>
      <div className="container">
        <div className={innerClasses}>
          <SectionHeader data={sectionHeader} className="center-content" />
          <div className={splitClasses}>
            <div className="split-item has-bottom-divider">
              <div
                className="split-item-content center-content-mobile reveal-from-left"
                data-reveal-container=".split-item"
              >
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  Pasiūlymo pateikimas
                </div>
                <h3 className="mt-0 mb-12"> Brėžiniai ir Vizualizacijos </h3>
                <p className="m-0">
                  Svarbu nurodyti tikslius gaminio išmatavimus, aprašyti norimą
                  dizainą, nurodant pageidaujamas medžiagas jų spalvas ir kitas
                  reikalingas specifikacijas. Matmenis siųsti:
                  <u className="text-color-primary "> info@inmetal.eu</u>
                </p>
              </div>
              <div
                className={classNames(
                  'split-item-image center-content-mobile reveal-from-bottom',
                  imageFill && 'split-item-image-fill '
                )}
                data-reveal-container=".split-item"
              >
                <Image
                  src={require('./../../assets/stair22.jpg')}
                  alt="Features split 01"
                  width={428}
                  height={296}
                />
              </div>
            </div>

            <div className="split-item has-bottom-divider">
              <div
                className="split-item-content center-content-mobile reveal-from-right"
                data-reveal-container=".split-item"
              >
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  sutarties pasirašymas
                </div>
                <h3 className="mt-0 mb-12">Gamyba</h3>
                <p className="m-0">
                  Patvirtinus gaminio dizainą ir paruošus brėžinius pasirašoma
                  sutartis, ir prasideda Jūsų užsakymo gaminimas mūsų ceche.
                </p>
              </div>
              <div
                className={classNames(
                  ' center-content-mobile reveal-from-bottom',
                  imageFill && 'split-item-image-fill'
                )}
                data-reveal-container=".split-item"
              >
                <Image
                  src={require('./../../assets/tablex2.jpg')}
                  alt="Features split 02"
                  width={428}
                  height={296}
                />
              </div>
            </div>

            <div className="split-item has-bottom-divider">
              <div
                className="split-item-content center-content-mobile reveal-from-left"
                data-reveal-container=".split-item"
              >
                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                  S-235 Plieno Tiekimas
                </div>
                <h3 className="mt-0 mb-12">Pristatymas visoje Lietuvoje</h3>
                <p className="m-0">
                  Mažmeninė ir didmeninė metalo prekyba. Plieno juostos,
                  armatūra. Platus vamzdžių asortimentas:{' '}
                </p>
                <ul
                  style={{ listStyle: 'none', margin: '25px 0px' }}
                  className="text-color-primary"
                >
                  <li>KVADRATINIAI</li>
                  <li>STAČIAKAMPIAI</li>
                  <li>PILNAVIDURIAI</li>
                </ul>
              </div>
              <div
                className={classNames(
                  'split-item-image center-content-mobile ',
                  imageFill && 'split-item-image-fill'
                )}
                data-reveal-container=".split-item"
              >
                <Image
                  src={require('./../../assets/iron-rods.jpg')}
                  alt="Features split 03"
                  width={528}
                  height={396}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

FeaturesSplit.propTypes = propTypes;
FeaturesSplit.defaultProps = defaultProps;

export default FeaturesSplit;
